/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {Login} from './components/Login'
import './css/AuthPage.css'
import NewLogo from './images/meter_meterarium_logo.gif'
import {meterariumBuildNumber} from 'GLOBAL/envVariables'

/* 점검 공지 팝업은 App 의 NoticeModal 로 옮겼다.
   문구와 노출 기간이 코드에 박혀 있어 공지 때마다 재배포가 필요했기 때문이다.
   지금은 서버의 /config/notice-config.json 을 읽고, /dev/notice-config 에서 편집한다. */

const AuthLayout = () => {
  useEffect(() => {
    document.body.style.backgroundImage = 'none'
  }, [])

  return (
    <>
      <div className={'wrap-bg w-full min-h-screen flex flex-col'}>
        {/* 메인 콘텐츠 */}
        <div className={'flex flex-1 flex-col items-center justify-center p-6 md:p-10'}>
          <div className={'flex flex-col md:flex-row items-center gap-8 md:gap-[80px] w-full md:w-auto'}>
            {/* 로고 */}
            <img
              alt='Logo'
              src={NewLogo}
              className={'w-[200px] md:w-[500px] rounded-full'}
            />

            {/* 로그인 폼 */}
            <div className={'login-bg-gradient shadow-sm p-8 md:p-10 w-full md:w-[500px] font-mono'}>
              <Outlet />
            </div>
          </div>
        </div>

        {/* 푸터 */}
        <div className={'flex justify-center pb-4 px-4'}>
          <div className={'flex flex-wrap justify-center items-center gap-x-2 gap-y-1 font-bold text-base md:text-[1.1rem]'}>
            <span className={'cursor-pointer hover:text-blue-500 px-2'}>영아이티(주)</span>
            <span className={'px-2'}>
              <a
                href={'https://young-it.co.kr'}
                className={'cursor-pointer hover:text-gray-800'}
                target={'_blank'}
                rel='noreferrer'
              >
                YOUNG-IT
              </a>{' '}
              | Meterarium
            </span>
            <span className={'px-2'}>
              <a href={'https://meterarium.dev:9088'} target={'_blank'} rel='noreferrer'>
                WASAP 고객지원
              </a>
            </span>
            <a href={'/join/agree'} className={'text-dark hover:text-blue-500 px-2'}>
              이용약관 및 개인정보처리방침
            </a>
            <span className={'px-2'}>
              <a href={'tel:042-932-0170'}>대표전화 : 042 - 932 - 0170</a>
            </span>
            <span className={'px-2'}>
              <a href={'tel:070-7835-7453'}>기술지원 : 070 - 7835 - 7453</a>
            </span>
            {meterariumBuildNumber && (
              <span className={'px-2 opacity-60'}>Ver : {meterariumBuildNumber}</span>
            )}
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  )
}

const AuthPage = (props: any) => {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path='login' element={<Login />} />
        <Route index element={<Login />} />
      </Route>
    </Routes>
  )
}

export {AuthPage}
